import { Theme, toast } from 'react-toastify';

const AUTO_CLOSE_TIME = 1500;

type NotificationOptions = {
  successMessage?: string;
  errorMessage?: string;
  infoMessage?: string;
  time?: number;
  theme?: Theme;
};

const wait = (delay: number) => new Promise((resolve) => setTimeout(resolve, delay));

export default function useNotification() {
  async function notifyWithPromise<T>(
    promise: Promise<T>,
    {
      successMessage = 'Thành công!',
      errorMessage = 'Có lỗi xảy ra!',
      infoMessage = 'Đang xử lý...',
      time = AUTO_CLOSE_TIME,
      theme = 'colored',
    }: NotificationOptions = {},
  ): Promise<T> {
    const id = toast.loading(infoMessage, {
      position: 'top-right',
      autoClose: false,
      hideProgressBar: true,
      closeOnClick: true,
      closeButton: false,
      theme,
    });

    const start = Date.now();

    try {
      const result = await promise;
      const elapsed = Date.now() - start;
      const delay = Math.max(0, 700 - elapsed);

      await wait(delay);
      toast.update(id, {
        render: successMessage,
        type: 'success',
        isLoading: false,
        autoClose: time,
        position: 'top-right',
        hideProgressBar: true,
        closeOnClick: true,
        closeButton: false,
        theme,
      });

      return result;
    } catch (err) {
      const elapsed = Date.now() - start;
      const delay = Math.max(0, 700 - elapsed);

      await wait(delay);
      toast.update(id, {
        render: errorMessage,
        type: 'error',
        isLoading: false,
        autoClose: time,
        position: 'top-right',
        hideProgressBar: true,
        closeOnClick: true,
        closeButton: false,
        theme,
      });

      throw err;
    }
  }

  return { notifyWithPromise };
}
